module.exports = __webpack_public_path__ + "static/img/img16_btn.93308ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c36/img16_btn.png
// module id = fp87
// module chunks = 0